import { RootState } from '@/store/store';
import { ModuleTree } from 'vuex';
import { courseActions } from './course.actions';
import { courseGetters } from './course.getter';
import { courseMutations } from './course.mutations';
import { courseState } from './course.state';

export default {
  namespaced: true,
  state: courseState,
  getters: courseGetters,
  actions: courseActions,
  mutations: courseMutations
} as ModuleTree<RootState>;
